import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to top on route change, but NOT when only the language segment changes.
function stripLang(pathname) {
  if (!pathname) return '';
  return pathname.replace(/^\/(hr|en)(?=\/|$)/, '') || '/';
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevRef = useRef(pathname);

  useEffect(() => {
    const prev = prevRef.current;
    prevRef.current = pathname;

    if (hash) return; // let anchor navigation work
    const changedOnlyLang = stripLang(prev) === stripLang(pathname) && prev !== pathname;
    if (changedOnlyLang) return;

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
